import api from '@/js/services/api';

export default {
    deactivateApplicant (id, form) {
        return api().post(`/master-admin/applicants/${id}/deactivate`, form);
    },

    reactivate(id) {
            return api().get(`/master-admin/applicants/${id}/activate`);
    },

    sendInterviewForm(form) {
        return api().post(`/master-admin/applicants/exit-interview/store`, form);
    },

    sendInterview(applicant_id, status_history_id) {
        const searchParams = new URLSearchParams();
        searchParams.append('status_history_id', status_history_id);

        return api().get(`/master-admin/applicants/${applicant_id}/deactivate/exit-interview/send?${searchParams.toString()}`);
    },

    updateStatus(status_history_id, note) {
        return api().put(`/master-admin/applicants/status-history/${status_history_id}/update`, note);
    },

    updateReactivationStatus(status_history_id, note) {
        return api().put(`/master-admin/applicants/status-history/${status_history_id}/update`, {note});
    }





}
